import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { EstadoPedido, MetodoPago, Pedido } from '../../models/pedido.model';
import { MatDialog } from '@angular/material/dialog';
import {
  ConfirmarDialogComponent,
  ConfirmDialogData,
} from 'src/app/main/backoffice/shared/components/dialogs/confirmar-dialog/confirmar-dialog.component';
import { PedidosService } from '../../services/pedidos.service';
import { SnackbarService } from 'src/app/main/backoffice/shared/services/snackbar.service';
import { HttpErrorResponse } from '@angular/common/http';
import { DetallesDialogComponent } from '../detalles-dialog/detalles-dialog.component';
import { error } from 'console';
import { EditarPedidoDialogComponent } from '../editar-pedido-dialog/editar-pedido-dialog.component';
import { TicketPrintComponent } from '../ticket-print/ticket-print.component';
import { SocketService } from 'src/app/shared/services/socket.service';

@Component({
  selector: 'app-pedidos-lista',
  templateUrl: './pedidos-lista.component.html',
  styleUrls: ['./pedidos-lista.component.scss'],
})
export class PedidosListaComponent implements OnInit {
  public displayedColumns: string[] = [
    'codigo',
    'metodoPago',
    'cliente',
    'fecha',
    'delivery',
    'destino',
    'estado',
    'total',
    'acciones',
  ];
  public dataSource = new MatTableDataSource<Pedido>();
  @Input() public pedidos: Pedido[] = [];
  @ViewChild(MatPaginator) public paginator!: MatPaginator;
  @Output() public changeEmmiter: EventEmitter<boolean> = new EventEmitter();

  @Input() filtro: string = '';

  estados = [
    EstadoPedido.Pendiente,
    EstadoPedido.Preparando,
    EstadoPedido.Listo,
    EstadoPedido.Enviando,
    EstadoPedido.Entregado,
    EstadoPedido.Cancelado,
  ];

  constructor(
    private readonly matDialog: MatDialog,
    private readonly _pedidosService: PedidosService,
    private readonly _snackbarService: SnackbarService,
  ) {}

  ngOnInit(): void {
    this.dataSource.data = this.pedidos;

    this.dataSource.filterPredicate = (
      pedido: Pedido,
      filter: string,
    ): boolean => {
      return pedido.customerName
        ?.toLowerCase()
        .includes(filter.trim().toLowerCase());
    };
  }

  ngOnChanges(): void {
    this.dataSource.data = this.pedidos;

    this.dataSource.filter = this.filtro.trim().toLowerCase();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  ngOnDestroy(): void {}

  public eliminarPedido(pedido: Pedido): void {
    let dialogEliminar = this.matDialog.open<
      ConfirmarDialogComponent,
      ConfirmDialogData,
      boolean
    >(ConfirmarDialogComponent, {
      data: {
        titulo: 'Eliminar pedido',
        mensaje: `¿Seguro que deseas eliminar el pedido de ${pedido.customerName}?`,
        textoBotonCancelar: 'Cerrar',
        textoBotonConfirmar: 'Confirmar',
      },
      disableClose: true,
    });
    dialogEliminar.afterClosed().subscribe((res) => {
      if (!res) return;
      this._pedidosService.eliminarPedido(pedido.id).subscribe(
        (res) => {
          this._snackbarService.success(
            'Éxito',
            'Se ha eliminado el pedido con éxito',
            7000,
          );
          this.changeEmmiter.emit(true);
        },
        (error: HttpErrorResponse) => {
          this._snackbarService.error('Error', error.message, 7000);
        },
      );
    });
  }

  public editarPedido(pedido: Pedido): void {
    let dialog = this.matDialog.open(EditarPedidoDialogComponent, {
      width: '900px',
      data: pedido,
    });

    dialog.afterClosed().subscribe((res) => {
      if (!res) return;
      this.changeEmmiter.emit(true);
    });
  }

  public consultarDetalles(pedido: Pedido): void {
    let dialogDetalles = this.matDialog.open<
      DetallesDialogComponent,
      { pedidoId: number },
      boolean
    >(DetallesDialogComponent, {
      data: { pedidoId: pedido.id },
      disableClose: true,
      width: '700px',
    });
  }

  public getEstadoClase(estado: number): string {
    switch (estado) {
      case EstadoPedido.Pendiente:
        return 'pendiente';
      case EstadoPedido.Preparando:
        return 'preparando';
      case EstadoPedido.Listo:
        return 'listo';
      case EstadoPedido.Enviando:
        return 'enviando';
      case EstadoPedido.Entregado:
        return 'entregado';
      case EstadoPedido.Cancelado:
        return 'cancelado';
      default:
        return '';
    }
  }

  public getEstadoTexto(estado: number): string {
    return EstadoPedido[estado];
  }

  public getMetodoPagoTexto(value: number): string {
    return MetodoPago[value];
  }

  public cambiarEstado(pedido: Pedido, nuevoEstado: EstadoPedido) {
    pedido.status = nuevoEstado;

    this._pedidosService
      .actualizarEstadoPedido(pedido.id, nuevoEstado)
      .subscribe({
        next: (res) => {
          this._snackbarService.success(
            'Éxito',
            'Se ha cambiado correctamente el estado del pedido',
            7000,
          );
          this.changeEmmiter.emit(true);
        },
        error: (error: HttpErrorResponse) => {
          this._snackbarService.error('Error', error.message, 7000);
        },
      });
  }

  public imprimirPedido(pedido: Pedido): void {
    this.matDialog.open(TicketPrintComponent, {
      data: pedido,
      panelClass: 'print-dialog',
    });
  }
}
